import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-view options",
  "use": "icon-view options-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" id=\"icon-view options\"><title></title><path d=\"M89.88,50c0,13.73-23.42,24.85-39.36,24.85S10.12,63.73,10.12,50s24.47-24.85,40.4-24.85S89.88,36.27,89.88,50Z\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"5\" /><circle cx=\"50\" cy=\"50\" r=\"8.21\" fill=\"currentColor\" stroke=\"currentColor\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol